import { createContext, useContext } from 'react';

interface LayoutContextProps {
    leftSidebarEnabled: boolean;
    rightSidebarEnabled: boolean;
}
export const LayoutContext = createContext<LayoutContextProps>({
    leftSidebarEnabled: false,
    rightSidebarEnabled: false,
});

export const useLayoutContext = (): LayoutContextProps => useContext(LayoutContext);
